/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AppleCalendarLinkData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsAppleCalendarLink: build.query<AppleCalendarLinkData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/calendar/apple-link` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsAppleCalendarLinkApi };
export const { useGetSettingsAppleCalendarLinkQuery, useLazyGetSettingsAppleCalendarLinkQuery } = injectedRtkApi;
